import * as firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCnEJSmxB15qttu7xaRvjg8AzbwPq0nomQ",
    authDomain: "muong14-f9b71.firebaseapp.com",
    databaseURL: "https://muong14-f9b71.firebaseio.com",
    projectId: "muong14-f9b71",
    storageBucket: "muong14-f9b71.appspot.com",
    messagingSenderId: "135766180855",
    appId: "1:135766180855:web:00e0bee5381d7a577464f2",
    measurementId: "G-TK2FR7WWH2"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export {firebase, googleAuthProvider, database as default};